import { IIcons } from '../../components/atoms/icons';

const KEY = 'locale';

const localeValues = {
	'pt-BR': 'pt-BR',
	'en-US': 'en-US',
	'es-ES': 'es-ES',
} as const;

export type Locale = keyof typeof localeValues;

export const locales: Locale[] = Object.keys(localeValues) as Locale[];

export const getLocale = (): Locale => {
	return (localStorage.getItem(KEY) as Locale) || 'pt-BR';
};

export const setLocale = (locale: Locale): void => {
	localStorage.setItem(KEY, locale);
};

export interface LanguageOptions {
	key: Locale;
	label: string;
	icon: IIcons;
}

export const languageOptions: LanguageOptions[] = [
	{ key: 'en-US', label: 'English', icon: 'FlagUS' },
	{ key: 'es-ES', label: 'Español', icon: 'FlagES' },
	{ key: 'pt-BR', label: 'Português', icon: 'FlagBR' },
];
